// URL della dashboard esterna dei risultati: il modello (es. variabile
// REACT_APP_EXPERIMENTS_DASHBOARD_URL) contiene {tenant} ed {experimentId}
export function dashboardUrl(template, tenant, experimentId) {
  if (!template || !experimentId) return undefined;

  return template
    .replaceAll("{tenant}", encodeURIComponent(tenant ?? ""))
    .replaceAll("{experimentId}", encodeURIComponent(experimentId));
}
